// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  receiptKey: __t.string().primaryKey().name("receipt_key"),
  opId: __t.u64().name("op_id"),
  template: __t.string(),
  slot: __t.string(),
  evidenceId: __t.string().name("evidence_id"),
  beneficiary: __t.identity(),
  amountSov: __t.i64().name("amount_sov"),
  crewJson: __t.string().name("crew_json"),
  splitRev: __t.u32().name("split_rev"),
  order: __t.u32(),
  detail: __t.string(),
  acceptedAt: __t.timestamp().name("accepted_at"),
  paidAt: __t.timestamp().name("paid_at"),
  payTxId: __t.u64().name("pay_tx_id"),
});
